// extracted by mini-css-extract-plugin
export default {"label":"ResourceLabel_label__Q2Lfg"};